import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import { publicCrosswalk1, recommendationEdge, recommendationSwitch } from '@assets/images/solution/recommendation';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/publicCrosswalk/img/1.avif';
import image2 from '@src/assets/images/solution/publicCrosswalk/img/2.avif';
import image3 from '@src/assets/images/solution/publicCrosswalk/img/3.avif';
import image4 from '@src/assets/images/solution/publicCrosswalk/img/4.avif';
import image5 from '@src/assets/images/solution/publicCrosswalk/img/5.avif';
import image6 from '@src/assets/images/solution/publicCrosswalk/img/6.avif';
import image7 from '@src/assets/images/solution/publicCrosswalk/img/7.avif';
import recommendation from '../common/recommendation';

export default {
  type: '城市安全解决方案',

  recommend: {
    title: '',
    desc: 'ORBRO OS 是一款强大的实时定位追踪与智能监控平台。<br/>完美融合 BLE、UWB 及 AI 视频分析技术，专为提升城市环境的安全性、效率与可扩展性而设计。',
    labels: {
      desktop: [
        { img: publicCrosswalk1, data: recommendation.ptzCamera },
        { img: recommendationEdge, data: recommendation.edgeRtls },
        { img: recommendationSwitch, data: recommendation.switch },
      ],
      mobile: [{ data: recommendation.ptzCamera }, { data: recommendation.edgeAi }, { data: recommendation.switch }],
    },
  },

  banner: {
    title: '防止人行横道事故，守护行人安全。',
    desc: 'AI 识别车辆与行人移动，一旦存在碰撞风险，立即通过 LED 显示屏和扬声器进行警告。',
  },

  numOfCard: {
    title: '通过 AI，实现人行横道事故“零”发生',
    desc: '实时识别目标并进行双向警告，从根本上杜绝右转车路口的行人事故。',
    card: [
      {
        tag: '99.9%',
        title: '目标识别准确率',
        desc: '精确检测行人、自行车、电动车等多种对象',
      },
      {
        tag: '100+',
        title: '同时识别对象数量',
        desc: '可实时追踪多个目标',
      },
      {
        tag: '0',
        title: '系统安装后致命事故',
        desc: '安装后右转路口无死亡事故',
      },
      {
        tag: '0',
        title: '系统安装后受伤事故',
        desc: '通过警告预防所有潜在碰撞',
      },
    ],
  },

  func: [
    {
      theme: '精准识别车与人的碰撞风险，立即发出警告。',
      title: '实时 AI 分析车辆与行人',
      desc: 'AI 实时判断车辆与行人的位置、速度与方向。即便在视野受限区域，也能精确识别儿童、婴儿车、自行车、电动车等对象。',
      sub1: '高识别准确度',
      icon1: IconRulerGray,
      sub2: '实时状态监控',
      icon2: IconClockGray,
      image: image2,
    },
    {
      title: '基于相对位置与方向判断碰撞风险',
      desc: '系统综合分析轨迹、速度与方向，仅在路径交汇或接近时发警告，确保预警的准确性与可靠性。',
      sub2: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub1: '快速数据联动',
      icon2: IconTvocGray,
      image: image3,
    },
    {
      title: 'LED 与扬声器双向警示',
      desc: '在路口两侧安装屏幕，为驾驶员提示行人接近；扬声器则为行人警示车辆来临，大幅降低事故风险。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '高识别准确度',
      icon2: IconRulerGray,
      image: image4,
    },
    {
      theme: '高效部署与简单运营，确保最佳安全性能。',
      title: 'Edge AI 本地处理，保障数据安全',
      desc: '现场部署服务器保护数据，防止外泄。采用本地方式运行，兼顾隐私与管理效率。',
      sub1: '灵活设置监控区域',
      icon1: IconZoneGray,
      sub2: '支持多区域配置',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: '可针对高风险区域制定部署方案',
      desc: '可在高发事故路口或学校区等特定地点部署 AI 视频分析系统，以实际场景定制化管理。',
      sub1: '灵活设置监控区域',
      icon1: IconZoneGray,
      sub2: '支持多区域配置',
      icon2: IconTagGray,
      image: image6,
    },
    {
      title: '兼容多品牌摄像头',
      desc: '支持多家制造商设备接入，不仅可利用现有系统，还能便于未来扩展与升级。',
      sub1: '灵活设置监控区域',
      icon1: IconZoneGray,
      sub2: '支持多区域配置',
      icon2: IconTagGray,
      image: image7,
    },
  ],

  subfunc: {
    title: '功能概览',
    desc: '保护行人安全能提升效率、减少损失。ORBRO 提供专为复杂城市环境与交叉路口设计的安全功能。',
    data: [
      {
        icon: IconSearch,
        title: '多对象识别',
        desc: '同一时刻精准识别儿童、婴儿车、自行车、电动车等多种目标。',
      },
      {
        icon: IconRoute,
        title: '实时位置与轨迹追踪',
        desc: '监控每个目标的方位、速度与移动轨迹。',
      },
      {
        icon: IconAnalytics,
        title: '碰撞风险评估算法',
        desc: '基于距离与轨迹交叉情况，精准计算可能性。',
      },
      {
        icon: IconChartBar,
        title: '双向警示设置',
        desc: '屏幕提示司机，扬声器提醒行人，即刻传递安全警报。',
      },
      {
        icon: IconLayers,
        title: '视野盲区补足',
        desc: '在交叉口等盲区也能清晰检测行人。',
      },
      {
        icon: IconAnalytics,
        title: '精准警报阈值设置',
        desc: '根据距离与速度调整阈值，减少误报。',
      },
      {
        icon: IconLayers,
        title: '本地数据安全保障',
        desc: '全部数据就地处理，不外传，增强安全性。',
      },
      {
        icon: IconSearch,
        title: 'CCTV 简易集成',
        desc: '兼容多品牌摄像头，轻松接入现有系统。',
      },
    ],
  },

  system: {
    title: '系统配置',
    img: rtlsSystem,
  },

  productTitle: '产品阵容',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
